import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import {
  FETCH_MULTI_CART_SUMMARIES,
  FETCH_MULTI_CART_ITEMS,
  FETCH_MULTI_CART_MEMBERS,
  CREATE_MULTI_CART,
} from 'actions/apiActionConstants'
import { apiReducerSwitch, createAppReducer } from 'lib/redux/reducerUtils'

export const initialMultiCartState: App.MultiCartState = {
  cartSummary: {
    carts: {},
    fetching: false,
    error: undefined,
  },
  cartItems: {},
  cartUsers: {},
}

const apiCalls = apiReducerSwitch<App.MultiCartState>({
  [FETCH_MULTI_CART_SUMMARIES]: {
    request: (state) => ({
      cartSummary: {
        ...state.cartSummary,
        fetching: true,
        error: undefined,
      }
    }),
    success: (state, action) => ({
      cartSummary: {
        ...state.cartSummary,
        carts: action.data,
        fetching: false,
      }
    }),
    failure: (state, action) => ({
      cartSummary: {
        ...state.cartSummary,
        fetching: false,
        error: action.error,
      }
    }),
  },
  [FETCH_MULTI_CART_MEMBERS]: {
    request: (state, action) => ({
      cartUsers: {
        ...state.cartUsers,
        [action.cartId]: {
          ...state.cartUsers[action.cartId],
          fetching: true,
          error: undefined,
        }
      }
    }),
    success: (state, action) => ({
      cartUsers: {
        ...state.cartUsers,
        [action.cartId]: {
          users: action.data,
          fetching: false,
        }
      }
    }),
    failure: (state, action) => ({
      cartUsers: {
        ...state.cartUsers,
        [action.cartId]: {
          ...state.cartUsers[action.cartId],
          fetching: false,
          error: action.error
        }
      }
    }),
  },
  [FETCH_MULTI_CART_ITEMS]: {
    request: (state, action) => ({
      cartItems: {
        ...state.cartItems,
        [action.cartId]: {
          ...state.cartItems[action.cartId],
          fetching: true,
          error: undefined,
        }
      }
    }),
    success: (state, action) => ({
      cartItems: {
        ...state.cartItems,
        [action.cartId]: {
          items: action.data,
          fetching: false,
          error: undefined,
        }
      }
    }),
    failure: (state, action) => ({
      cartItems: {
        ...state.cartItems,
        [action.cartId]: {
          ...state.cartItems[action.cartId],
          fetching: false,
          error: action.error,
        }
      }
    }),
  },
  [CREATE_MULTI_CART]: {
    request: (state) => ({
      cartSummary: {
        ...state.cartSummary,
        fetching: true,
        error: undefined
      }
    }),
    success: (state, action) => ({
      cartSummary: {
        ...state.cartSummary,
        carts: {
          ...state.cartSummary.carts,
          [action.data.cartId]: action.data
        },
        fetching: false,
        error: undefined
      }
    }),
    failure: (state, action) => ({
      cartSummary: {
        ...state.cartSummary,
        fetching: false,
        error: action.error
      }
    }),
  },
})

export default createAppReducer<App.MultiCartState>(initialMultiCartState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
})
